<template>
    <ModalContainer
        :image="FennecCoinSilverLargeImage"
        :alt="$tr('modalSurvey.alt')"
        :isOpened="isSurveyModalOpened"
        @closeModal="onCloseModal"
    >
        <template
            v-if="surveyModalOpenData"
            #custom-content
        >
            <fieldset :class="$style.fieldset">
                <Typography
                    is="legend"
                    type="header"
                    size="s"
                    :responsive="false"
                    :class="$style.legend"
                >
                    {{ surveyModalOpenData?.question }}
                </Typography>
                <Typography
                    is="p"
                    :class="$style.description"
                    size="s"
                    :responsive="false"
                >
                    {{ $tr('modalSurvey.description') }}
                </Typography>
                <div :class="$style.feedback_list">
                    <label
                        v-for="option in surveyModalOpenData.options"
                        :key="option.selectedOptionId"
                        :class="$style.feedback"
                    >
                        <input
                            :id="option.selectedOptionId"
                            type="radio"
                            name="feedback"
                            :class="$style.hiddenInput"
                            @change="onSubmitModal({ id: option.selectedOptionId, text: option.selectedOptionText })"
                        />
                        <Icon
                            v-if="option.icon"
                            :name="option.icon"
                            :class="$style[option.icon]"
                        />
                        <Typography
                            type="label"
                            size="l"
                            accent
                            :responsive="false"
                        >
                            {{ option.selectedOption }}
                        </Typography>
                    </label>
                </div>
            </fieldset>
        </template>
    </ModalContainer>
</template>
<script setup lang="ts">
import ModalContainer from '@/components_new/ModalItems/ModalContainer.vue'
import Icon from '@/components_new/Icon/Icon.vue'
import FennecCoinSilverLargeImage from '@/components_new/ModalItems/images/silver-fennec-coin-large.webp'
import Typography from '@/components_new/Typography.vue'
import { SurveyData } from './types'
import { useTr } from '@/composables/use-tr'
import { getSurveyQuestion } from './utils'
import { computed } from 'vue'
import { useLayoutStore } from '@/store/layout-store'
import { useTasksStore } from '@/components_new/TaskItems/store'
import { useLoggerStore } from '@/store/logger'
import { storeToRefs } from 'pinia'
import { useI18nAddon } from '@/i18n/i18n'
import { useUserStore } from '@/store/user-store/user-store'

const layoutStore = useLayoutStore()
const { isSurveyModalOpened, questionSurveyInfo } = storeToRefs(layoutStore)
const loggerStore = useLoggerStore()
const taskStore = useTasksStore()
const userStore = useUserStore()
const { user } = storeToRefs(userStore)
const { currentLocale } = useI18nAddon()

async function onSubmitModal({ id, text }: { id: string; text: string }) {
    const localeInfo = window.additionalServerData?.locale
    loggerStore.logSurveyEvent({
        gameHru: questionSurveyInfo.value!.hru,
        userId: user.value!._id,
        country: localeInfo?.countryNameEn || 'unknown',
        eventName: 'survey_game_completed',
        locale: currentLocale.value,
        questionId: surveyModalOpenData.value!.questionId,
        selectedOptionText: text,
        selectedOptionId: id,
        questionText: surveyModalOpenData.value!.questionText,
    })
    await taskStore.claimTask(questionSurveyInfo.value!.taskId)
    onCloseModal()
}
const tr = useTr()

const surveyData = computed(() => getSurveyQuestion(tr))
const surveyModalOpenData = computed(() => getDailyQuestion(questionSurveyInfo.value?.questionSeedNum))

function getDailyQuestion(randomSeed: number | undefined): SurveyData | undefined {
    if (randomSeed === undefined) {
        return undefined
    }
    const currentDayNum = new Date().getDay()
    const seedIndex = (currentDayNum + randomSeed) % surveyData.value.length
    return surveyData.value[seedIndex]
}

function onCloseModal() {
    layoutStore.setSurveyModalSurveyInfo(null)
}
</script>
<style module>
.fieldset {
    display: flex;
    align-items: center;
    flex-direction: column;
    border: 0;
    padding: 0;
    margin: 0;
}

.legend {
    padding: 0;
    margin: 0;
    margin-top: 8px;
    text-align: center;
}
.description {
    color: rgba(255, 255, 255, 0.6);
    text-align: center;
    margin-top: 12px;
    margin-bottom: 24px;
}
.feedback_list {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 8px;
}

.feedback {
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: var(--carbon-400);
    padding: 12px 16px;
    border-radius: 16px;
    cursor: pointer;
    justify-content: center;
    filter: none;
}

.hiddenInput {
    position: absolute;
    opacity: 0;
    pointer-events: none;
}

.feedback:hover,
.feedback:focus-within {
    filter: brightness(1.08);
}

.heart {
    color: #fd7196;
}

.poop {
    color: #95592e;
}

.smile {
    color: #ffd147;
}
</style>
